export enum RoundingMethod {
Closest,
Ceil,
Floor,
}
